import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames/bind';
import BaseRenderer from './BaseRenderer';
import Icon from '../Icon/Icon';

export default class IconRenderer extends PureComponent {

  static displayName = 'IconRenderer';

  static propTypes = {
    className: PropTypes.string,
    description: PropTypes.string, // eslint-disable-line
    error: PropTypes.string, // eslint-disable-line
    footer: PropTypes.node, // eslint-disable-line
    icon: PropTypes.node,
    iconName: PropTypes.string,
    item: PropTypes.object, // eslint-disable-line
    level: PropTypes.number, // eslint-disable-line
    linked: PropTypes.bool,
    locked: PropTypes.bool,
    onCreateMenuItems: PropTypes.func, // eslint-disable-line
    onCloseMenu: PropTypes.func, // eslint-disable-line
    tag: PropTypes.string, // eslint-disable-line
    tags: PropTypes.arrayOf(PropTypes.string), // eslint-disable-line
    title: PropTypes.node, // eslint-disable-line
    warning: PropTypes.string, // eslint-disable-line
  };

  render() {
    const { className, icon, iconName, linked, locked, ...rest } = this.props;
    const icons = [
      linked && <Icon key="link" name="link"/>,
      locked && <Icon key="locked" name="lock"/>,
    ];

    return (
      <BaseRenderer {...rest} icons={icons} className={cx('core-icon-renderer', className)}>
        <Icon icon={icon} name={iconName}/>
      </BaseRenderer>
    );
  }

}
